import { getFetch, postFetch, postFetchWithBody, postFetchWithToken } from "../../utils/fetch";

async function storeCargoLicense(form) {
  const res = await postFetchWithBody("/Cargo/store-license", form);
  if (res.status !== "error") {
    if (res.code === "407") {
      return {
        status: "error",
        message: "نام کاربری از قبل برای کاربر دیگر ثبت شده!",
      };
    }
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: res.message,
    };
  }
}
async function deleteLicenseCargo(form) {
  const res = await postFetchWithBody("/Cargo/delete-license", form);
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: res.message,
    };
  }
}
async function deleteCargo(form) {
  const res = await postFetchWithBody("/Cargo/deleteCargo", form);
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: res.message,
    };
  }
}
export const getCargoById = async (id) => {
  try {
    const response = await getFetch(`/Cargo/${id}`);

    if (response.status === 'error') {
      return {
        status: 'error',
        message: response.message
      };
    }

    const cargo = response.data;

    // تبدیل ساختار داده به فرم مورد نیاز فرم ویرایش
    return {
      status: 'success',
      data: {
        ...cargo,
        machine_id: cargo.machine?.id || null,
        driver_id: cargo.driver?.id || null,
        equipment_id: cargo.equipment?.id || null,
        operator_id: cargo.operator?.id || null,
        project_id: cargo.project?.id || null,
        location_id: cargo.location?.id || null,
        peymankar_id: cargo.peymankar?.id || null,
        origin_id: cargo.origin?.id || null,
        destination_id: cargo.destination?.id || null,
        shift_id: cargo.shift?.id || null,
        jensItems: cargo.jens?.map(item => ({
          id: item.id,
          jens_id: item.jens?.id || null,
          jens_code_id: item.jens_code?.id || null,
          jens_unit: item.jens_unit || null,
          jens_number: item.jens_number || null,
          weight_id: item.weight?.id || null,
          weight_unit: item.weight_unit || null
        })) || []
      }
    };
  } catch (error) {
    console.error('Error fetching cargo:', error);
    return {
      status: 'error',
      message: 'خطا در دریافت اطلاعات بارگیری'
    };
  }
};
export const getLicenseCargoById = async (id) => {
  try {
    const response = await getFetch(`/Cargo/license/${id}`);

    if (response.status === 'error') {
      return {
        status: 'error',
        message: response.message
      };
    }

    const cargo = response.data;

    return {
      status: 'success',
      data: {
        ...cargo,
        machine_id: cargo.machine?.id || null,
        driver_id: cargo.driver?.id || null,
        equipment_id: cargo.equipment?.id || null,
        operator_id: cargo.operator?.id || null,
        project_id: cargo.project?.id || null,
        location_id: cargo.location?.id || null,
        peymankar_id: cargo.peymankar?.id || null,
        origin_id: cargo.origin?.id || null,
        destination_id: cargo.destination?.id || null,
        shift_id: cargo.shift?.id || null,
        jensItems: cargo.jens?.map(item => ({
          id: item.id,
          jens_id: item.jens?.id || null,
          jens_code_id: item.jens_code?.id || null,
          jens_unit: item.jens_unit || null,
          jens_number: item.jens_number || null,
          weight_id: item.weight?.id || null,
          weight_unit: item.weight_unit || null
        })) || []
      }
    };
  } catch (error) {
    console.error('Error fetching cargo:', error);
    return {
      status: 'error',
      message: 'خطا در دریافت اطلاعات بارگیری'
    };
  }
};
export const updateLicenseCargo = async (data) => {
  try {
    const response = await postFetchWithBody('/Cargo/update/license', data);

    if (response.status === 'error') {
      return {
        status: 'error',
        message: response.message
      };
    }

    return {
      status: 'success',
      message: 'بارگیری با موفقیت ویرایش شد',
      data: response.data
    };
  } catch (error) {
    console.error('Error updating cargo:', error);
    return {
      status: 'error',
      message: 'خطا در ویرایش بارگیری'
    };
  }
};

/**
 * ویرایش بارگیری
 * @param {object} data - داده‌های بارگیری
 * @returns {Promise<{status: string, message: string, data?: object}>}
 */
export const updateCargo = async (data) => {
  try {
    const response = await postFetchWithBody('/Cargo/update', data);

    if (response.status === 'error') {
      return {
        status: 'error',
        message: response.message
      };
    }

    return {
      status: 'success',
      message: 'بارگیری با موفقیت ویرایش شد',
      data: response.data
    };
  } catch (error) {
    console.error('Error updating cargo:', error);
    return {
      status: 'error',
      message: 'خطا در ویرایش بارگیری'
    };
  }
};

async function downloadAllReport() {
  const data = await getFetch('/ReportWeb/Reports/download-report-license');
  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}

export { storeCargoLicense,deleteCargo,deleteLicenseCargo,downloadAllReport };
